import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { MatButton } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { AccountService } from '../../../services/account.service';
import { SnackbarService } from '../../../services/snackbar.service';
import { environment } from '../../../../environments/environment';
import { SetNewPasswordRequest } from '../../../model/userModel';

@Component({
  selector: 'app-set-new-password',
  imports: [
    ReactiveFormsModule,
    MatFormField,
    MatInput,
    MatLabel,
    MatButton,
    MatCardModule,
    RouterLink,
  ],
  templateUrl: './set-new-password.component.html',
  styleUrl: './set-new-password.component.scss',
})
export class SetNewPasswordComponent implements OnInit {
  private fb = inject(FormBuilder);
  accountService = inject(AccountService);
  private router = inject(Router);
  private snackbar = inject(SnackbarService);
  private route = inject(ActivatedRoute);

  production = environment.production;
  height = 0;

  loginForm = this.fb.group({
    newPassword: [''],
    newPasswordConfirm: [''],
  });

  ngOnInit(): void {
    this.accountService.twoFAUser$.subscribe((user) => {
      if (!user) {
        this.router.navigate(['/login']);
      }
    });
    this.accountService.user$.subscribe((user) => {
      if (user) {
        this.route.queryParams.subscribe((params) => {
          const returnUrl = params['returnUrl'] || '/hours';
          this.router.navigate([returnUrl]);
        });
      }
    });
  }

  onSubmit(): void {
    var resquest: SetNewPasswordRequest = {
      newPassword: this.loginForm.value.newPassword ?? '',
      newPasswordConfirm: this.loginForm.value.newPasswordConfirm ?? '',
    };
    this.accountService.setNewPasswordForNewAccountSetup(resquest);
  }
}
